import Vue from 'vue'
// Notification
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import { createModule } from 'vuexok'
import router from '@/router'
import store from '@/store'
import { SmsListState, ISmsTemplatesListRequest } from './types'
import { cloneSmsTemplate, deleteSmsTemplate, fetchSmsTemplatesList } from '@/api/smsTemplates'
import { DEFAULT_PER_PAGE, PER_PAGE_OPTIONS } from '@/constants/base'
import setPerPage from '@/helpers/setPerPage'

// eslint-disable-next-line import/prefer-default-export
export const appSmsList = createModule(
  'appSmsList',
  {
    namespaced: true,
    state: {
      tableColumns: [
        { key: 'name', label: 'Name', sortable: true },
        { key: 'created_by', label: 'created by' },
        { key: 'actions', class: 'table-actions' },
      ],
      perPage: Number(localStorage.getItem('smsTemplatesPerPage')) || DEFAULT_PER_PAGE,
      totalItems: 0,
      currentPage: 1,
      perPageOptions: PER_PAGE_OPTIONS,
      searchQuery: '' as string | (string | null)[],
      sortBy: 'created_at',
      isSortDirDesc: true,
      dataMeta: {
        from: 0,
        to: 0,
        of: 0,
      },
    } as SmsListState,
    getters: {
      getTableColumns: state => state.tableColumns,
      getPerPage: state => state.perPage,
      getTotalItems: state => state.totalItems,
      getCurrentPage: state => state.currentPage,
      getPerPageOptions: state => state.perPageOptions,
      getSearchQuery: state => state.searchQuery,
      getSortBy: state => state.sortBy,
      getIsSortDirDesc: state => state.isSortDirDesc,
      getDataMeta: state => state.dataMeta,
    },
    mutations: {
      SET_PER_PAGE(state, val: number) {
        localStorage.setItem('smsTemplatesPerPage', val.toString())
        state.perPage = val
      },
      SET_TOTAL_ITEMS(state, val: number) {
        state.totalItems = val
      },
      SET_CURRENT_PAGE(state, val: number) {
        state.currentPage = val
      },
      SET_SEARCH_QUERY(state, val: string) {
        state.searchQuery = val
      },
      SET_SORT_BY(state, val: string) {
        state.sortBy = val
      },
      SET_IS_SORT_DESC(state, val: boolean) {
        state.isSortDirDesc = val
      },
      SET_DATA_META(state, val) {
        state.dataMeta = val
      },
      SET_FILTER_PARAMS(state) {
        const query = { ...router.currentRoute.query }
        const defaultPerPage = localStorage.getItem('smsTemplatesPerPage')
        state.currentPage = Number(query.currentPage) || 1
        state.perPage = setPerPage(query.perPage, defaultPerPage, DEFAULT_PER_PAGE)
        state.searchQuery = query.searchQuery || ''
      },
    },
    actions: {
      async fetchSmsTemplatesList({ state }) {
        try {
          const queryParams: ISmsTemplatesListRequest = {
            perPage: state.perPage,
            page: state.currentPage || 1,
            sortBy: state.sortBy,
            sortDesc: state.isSortDirDesc,
          }
          if (state.searchQuery) queryParams.name = state.searchQuery

          const response:any = await fetchSmsTemplatesList(queryParams)

          const {
            total, from, to,
          } = response.data.meta

          const dataMeta = {
            from,
            to,
            of: total,
          }

          appSmsList.mutations.SET_TOTAL_ITEMS(total)
          appSmsList.mutations.SET_DATA_META(dataMeta)
          return response.data.data
        } catch (error) {
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: "Error fetching letters' list",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          return []
        }
      },
      async deleteSmsTemplate(ctx, id) {
        try {
          await deleteSmsTemplate(id)
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: 'Success deleting SMS',
              icon: 'Trash2Icon',
              variant: 'info',
            },
          })
        } catch (error) {
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error deleting SMS',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      },
      async cloneSmsTemplate(ctx, id: string) {
        try {
          await cloneSmsTemplate(id)
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: 'Success cloning template',
              icon: 'Trash2Icon',
              variant: 'info',
            },
          })
        } catch (error) {
          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error cloning template',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      },
    },
  },
)

appSmsList.register(store)
